import React,{useEffect,useState} from "react";
import { auth, db, storage } from "../../firebase/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../../styles/ResellerSettings.css";

export default function ResellerSettings(){
  const [resellerId,setResellerId] = useState(null);
  const [saving,setSaving] = useState(false);
  const [uploading,setUploading] = useState(false);

  const [form,setForm] = useState({
    primary:"#7c3aed",
    accent:"#a78bfa",
    text:"#ffffff",
    logoURL:""
  });

  /* ---------- LOAD RESELLER ID ---------- */
  useEffect(()=>{
    const uid = auth.currentUser?.uid;
    if(!uid) return;

    (async()=>{
      const snap = await getDoc(doc(db,"users",uid));
      if(snap.exists()) setResellerId(snap.data().resellerId);
    })();
  },[]);

  /* ---------- LOAD BRANDING ---------- */
  useEffect(()=>{
    if(!resellerId) return;

    (async()=>{
      const snap = await getDoc(
        doc(db,`resellers/${resellerId}/branding/settings`)
      );
      if(snap.exists()){
        setForm(prev=>({...prev,...snap.data()}));
      }
    })();
  },[resellerId]);

  const field = k => e => setForm({...form,[k]:e.target.value});

  /* ---------- LOGO UPLOAD (FIXED + AUTH SAFE) ---------- */
  const uploadLogo = async(file)=>{
    if(!file || !resellerId) return;

    try{
      setUploading(true);

      // ✅ REVERTED to original safe path
      const storageRef = ref(
        storage,
        `branding/resellers/${resellerId}/logo.png`
      );

      await uploadBytes(storageRef,file);
      const url = await getDownloadURL(storageRef);

      setForm(f=>({...f,logoURL:url}));
    }catch(err){
      console.error(err);
      alert("Logo upload failed");
    }finally{
      setUploading(false);
    }
  };

  /* ---------- SAVE ---------- */
  const save = async()=>{
    if(!resellerId) return;

    setSaving(true);
    await setDoc(
      doc(db,`resellers/${resellerId}/branding/settings`),
      {...form,updatedAt:new Date().toISOString()},
      {merge:true}
    );
    setSaving(false);
    alert("Reseller branding saved");
  };

  return (
    <div className="reseller-settings-wrap">
      <h2 className="reseller-settings-title">Branding Settings</h2>

      <div className="reseller-settings-card">

        <div className="color-row">
          <Color label="Primary" value={form.primary} onChange={field("primary")} />
          <Color label="Accent" value={form.accent} onChange={field("accent")} />
          <Color label="Text" value={form.text} onChange={field("text")} />
        </div>

        <div className="logo-row">
          <label className="logo-upload-btn">
            {uploading ? "Uploading…" : "Choose logo"}
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={e=>uploadLogo(e.target.files[0])}
            />
          </label>

          {form.logoURL && (
            <img
              src={form.logoURL}
              alt="Logo preview"
              className="logo-preview"
            />
          )}
        </div>

        <button
          onClick={save}
          disabled={saving}
          className="save-branding-btn"
        >
          {saving ? "Saving…" : "Save Branding"}
        </button>

      </div>
    </div>
  );
}

/* ---------- SMALL UI ---------- */
function Color({label,value,onChange}){
  return (
    <div className="color-item">
      <label>{label}</label>
      <input type="color" value={value} onChange={onChange} />
    </div>
  );
}
